// extracted by mini-css-extract-plugin
export var grid = "_n-0";
export var span1 = "_n-2";
export var span10 = "_n-b";
export var span10L = "_n-z";
export var span10M = "_n-n";
export var span10Xl = "_n-1b";
export var span11 = "_n-c";
export var span11L = "_n-10";
export var span11M = "_n-o";
export var span11Xl = "_n-1c";
export var span12 = "_n-d";
export var span12L = "_n-11";
export var span12M = "_n-p";
export var span12Xl = "_n-1d";
export var span1L = "_n-q";
export var span1M = "_n-e";
export var span1Xl = "_n-12";
export var span2 = "_n-3";
export var span2L = "_n-r";
export var span2M = "_n-f";
export var span2Xl = "_n-13";
export var span3 = "_n-4";
export var span3L = "_n-s";
export var span3M = "_n-g";
export var span3Xl = "_n-14";
export var span4 = "_n-5";
export var span4L = "_n-t";
export var span4M = "_n-h";
export var span4Xl = "_n-15";
export var span5 = "_n-6";
export var span5L = "_n-u";
export var span5M = "_n-i";
export var span5Xl = "_n-16";
export var span6 = "_n-7";
export var span6L = "_n-v";
export var span6M = "_n-j";
export var span6Xl = "_n-17";
export var span7 = "_n-8";
export var span7L = "_n-w";
export var span7M = "_n-k";
export var span7Xl = "_n-18";
export var span8 = "_n-9";
export var span8L = "_n-x";
export var span8M = "_n-l";
export var span8Xl = "_n-19";
export var span9 = "_n-a";
export var span9L = "_n-y";
export var span9M = "_n-m";
export var span9Xl = "_n-1a";
export var stretch = "_n-1";